export const manifest = {
  screens: {
    scr_8fvpid: { name: "Overview", route: "/", state: {"currentView":"overview"}, position: {"x":160,"y":220} },
    scr_589i4e: { name: "BPS Rate Tables", route: "/", state: {"currentView":"rate-tables"}, position: {"x":1560,"y":220} },
    scr_t82s1o: { name: "CDS Tiers", route: "/", state: {"currentView":"cds-tiers"}, position: {"x":2960,"y":220} },
  },
  sections: {
    sec_3tko5e: { name: "Main Dashboard Views", x: 0, y: 0, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_3tko5e", children: [
      { kind: "screen", id: "scr_8fvpid" },
      { kind: "screen", id: "scr_589i4e" },
      { kind: "screen", id: "scr_t82s1o" },
    ] },
  ],
}
